import Head from "next/head";

import ContestsMain from "@/components/contests/contests-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function AirmilesGivAway() {
  return (
    <>
      <Head>
        <title>{seoData.AIRMILES_GIVEAWAY.title}</title>
        <SeoMetaData data={seoData.AIRMILES_GIVEAWAY} />
      </Head>

      <ContestsMain />
    </>
  );
}
